export var ApiRateLimitAlgorithmEnum;
(function (ApiRateLimitAlgorithmEnum) {
    ApiRateLimitAlgorithmEnum["BURST_ALLOWANCE"] = "burst_allowance";
    ApiRateLimitAlgorithmEnum["WINDOW_DURATION"] = "window_duration";
})(ApiRateLimitAlgorithmEnum || (ApiRateLimitAlgorithmEnum = {}));
export class IApiRateLimitAlgorithm {
}
ApiRateLimitAlgorithmEnum.BURST_ALLOWANCE, ApiRateLimitAlgorithmEnum.WINDOW_DURATION;
export var ApiRateLimitConfigEnum;
(function (ApiRateLimitConfigEnum) {
    ApiRateLimitConfigEnum["ALGORITHM"] = "algorithm";
    ApiRateLimitConfigEnum["COST"] = "cost";
    ApiRateLimitConfigEnum["MAXIMUM"] = "maximum";
})(ApiRateLimitConfigEnum || (ApiRateLimitConfigEnum = {}));
export var ApiRateLimitCostEnum;
(function (ApiRateLimitCostEnum) {
    ApiRateLimitCostEnum["SINGLE"] = "single";
    ApiRateLimitCostEnum["BULK"] = "bulk";
})(ApiRateLimitCostEnum || (ApiRateLimitCostEnum = {}));
export var ApiRateLimitCategoryEnum;
(function (ApiRateLimitCategoryEnum) {
    ApiRateLimitCategoryEnum["TRIGGER"] = "trigger";
    ApiRateLimitCategoryEnum["CONFIGURATION"] = "configuration";
    ApiRateLimitCategoryEnum["GLOBAL"] = "global";
})(ApiRateLimitCategoryEnum || (ApiRateLimitCategoryEnum = {}));
